module.exports = __webpack_public_path__ + "img/23.5c2c1b05.jpg";